import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AsappServiceUrls } from '@core/constants/endpoints.constants';
import { ApiClient } from '@core/services/api-client.http.service';

export interface MemberApplicationsProductsResponse {
  products: Array<{ id: number | string; name?: string; productName?: string }>;
  recentApplicationsCount: number;
}

export interface MemberConversationSummaryRequest {
  memberNumber: string;
  memberId: string;
  refresh?: boolean;
  conversationData: Array<{
    conversationType: string;
    subject?: string;
    description?: string;
    assignedTo?: { id: string; firstName: string; lastName: string };
    status: string;
  }>;
}

export interface MemberConversationSummaryResponse {
  activity: string[];
  memberSummary: string;
  lastGeneratedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class MemberAiSummaryApiService {
  constructor(private api: ApiClient) { }

  getApplicationsAndProducts(memberNumber: string, memberId: number): Observable<MemberApplicationsProductsResponse> {
    return this.api.get<MemberApplicationsProductsResponse>(
      AsappServiceUrls.applicationsProducts(memberNumber),
      { memberId }
    );
  }

  getConversationSummary(request: MemberConversationSummaryRequest): Observable<MemberConversationSummaryResponse> {
    return this.api.post<MemberConversationSummaryResponse>(AsappServiceUrls.conversationDetails, request);
  }
}
